import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';



import './Navbar.css';

const CustomNavbar = () => {
  return (
    <Navbar  expand="lg" className="custom-navbar">
      <Container>
        {/* Left: Brand Logo */}
        <Navbar.Brand href="/" className="navbar-logo">
          Atastra
        </Navbar.Brand>

        {/* Navbar Toggler for smaller screens */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        {/* Collapsible Content */}
        <Navbar.Collapse id="navbar-nav">
          {/* Center: Links */}
          <Nav className="mx-auto navbar-links">
          <Nav.Link href="#enterprise" data-info="Our tailored training programs equip your team with the tools and expertise to thrive in an AI-driven world.">
    AI Training
</Nav.Link>
<Nav.Link href="#government" data-info="We develop and train custom models designed exclusively for your unique applications.">
    Custom Models
</Nav.Link>
<Nav.Link href="#customers" data-info="Revolutionize operations with cutting-edge edge computing deployments.">
    Deployments
</Nav.Link>
<Nav.Link href="#resources" data-info="Partnered with industry leaders, we drive innovation to shape the future of technology.">
    Research
</Nav.Link>
          </Nav>

          {/* Right: Buttons */}
          <div className="d-flex navbar-buttons">
            <Button variant="outline-light" className="btn-login" href="#login" >
              Log In
            </Button>
            <Button className="btn-book" href="#book-demo" data-info="Book a live demo session">
              Book a Demo
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
